import React, {Component} from 'react';
import './Signup.css';
class Signup extends React.Component {
  render() {
    return <div>

  <div className="container ">

      <div className="text-center p-5">
            <a className="" href=""> <img src="/assets/images/logo/logo.jpg" alt="" title="" className="img-fluid mb-2" /> </a><br/>
            <a className="" href=""> <img src="/assets/images/logo/logo-4.png" alt="" title="" className="img-fluid " /> </a><br/>
            <button type="button" class=" add-to-cart2 btnn ">Log In</button>
            <br/>
            <button type="button" class="  btnn  btn-outline-green ">Sign Up</button>      </div>

  </div>


    </div>
    }
}

export default Signup;
